<template>
  <div>
    <page-head
      :title="title"
      :show-back="true"
    ></page-head>
    <div class="content">
      <div class="card" v-if="isWorkSpecialClasses">
        <div class="card-header d-flex justify-content-between align-items-center">
          工作回复
          <div class="btn-group text-right">
            <Button
              class="bkcc-btn"
              @click="handleBtn('replyOpenModel')"
              >回复</Button>
          </div>
        </div>
        <div class="card-body text-gray">
          {{info.reply || '暂无回复'}}
        </div>
      </div>
      <div class="search">
        <Form>
          <div class="card">
            <div class="card-body">
              <row class="form-item-group">
                <i-col>
                  <FormItem label="服务企业">
                    <div class="detail">{{ info.name }}</div>
                  </FormItem>
                </i-col>
                <i-col>
                  <FormItem label="服务时间">
                    <div class="detail">{{ info.recordDate }}</div>
                  </FormItem>
                </i-col>
                <i-col>
                  <FormItem label="工作内容">
                    <div class="detail">{{ info.record }}</div>
                  </FormItem>
                </i-col>
                <i-col>
                  <FormItem label="提交日期">
                    <div class="detail">{{ info.createTime }}</div>
                  </FormItem>
                </i-col>
                <i-col>
                  <FormItem label="服务场景">
                    <div class="imgbox">
                    <el-image
                      v-for="(item, index) in info.pictures" :key="index"
                      :src="item"
                      :preview-src-list="info.pictures"
                      style="width: 200px;height: 200px;margin-right:12px;margin-top: 12px;"
                    />
                    </div>
                  </FormItem>
                </i-col>
              </row>
            </div>
          </div>
          <div class="serve-company card">
            <div class="card-header">
              本次服务收集问题或建议
            </div>
            <div class="card-body">
              <row :gutter="80">
                <i-col
                  span="24"
                  class="question"
                  v-for="(collectionQ, index) in collections"
                  :key="collectionQ.id"
                >
                  <div class="card-title">收集问题{{ index + 1 }}</div>
                  <FormItem label="问题类型">
                    <div class="detail">
                      {{ questionType(collectionQ.questionType) }}
                    </div>
                  </FormItem>
                  <FormItem label="问题内容">
                    <div class="detail">{{ collectionQ.questionInfo }}</div>
                  </FormItem>
                  <div class="summary">
                    <Checkbox :value="collectionQ.isMeeting === 1" disabled
                      >提交工作专班召集有关部门会商研究解决</Checkbox
                    >
                  </div>
                </i-col>
              </row>
            </div>
          </div>
          <div class="serve-company card">
            <div class="card-header">
              本次服务解决问题情况
            </div>
            <div class="card-body">
              <row :gutter="80">
                <i-col
                  span="24"
                  class="question"
                  v-for="(resolveQ, index) in resolves"
                  :key="resolveQ.id"
                >
                  <div class="card-title">解决问题{{ index + 1 }}</div>
                  <FormItem label="问题类型">
                    <div class="detail">
                      {{ questionType(resolveQ.questionType) }}
                    </div>
                  </FormItem>
                  <FormItem label="解决情况">
                    <div class="detail">
                      {{ resolveQ.questionInfo }}
                    </div>
                  </FormItem>
                </i-col>
              </row>
            </div>
          </div>
        </Form>
      </div>
    </div>
    <Modal v-model="modalIsOpen" :title="'回复'" :width="550">
      <Input
        type="textarea"
        v-model="replyMsg"
        :rows="5"
        placeholder="请填写回复..."
      />
      <div slot="footer">
        <Button style="margin-right:10px" @click="modalIsOpen = false"
          >取消</Button
        >
        <Button type="primary" @click="replyHandler" :loading="isBtbLoading"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { getChiefWaiterDocumentaryWorkDetail, postReplyWorkSpecialClasses } = api;
import { getQuestionTypeDic } from "./dic";
export default {
  name: "documentaryWorkDetail",
  components: {
    pageHead
  },
  data() {
    return {
      replyMsg: '',
      modalIsOpen: false,
      isBtbLoading: false,
      isWorkSpecialClasses: false,
      questionTypeList: [],
      info: {},
      collections: [],
      resolves: []
    };
  },
  computed: {
    title() {
      return this.isWorkSpecialClasses ? "工作专班" : "工作记实";
    }
  },
  methods: {
    handleBtn(type, params) {
      const handler = this[type + "Handler"];
      if (params) {
        handler && handler(params);
      } else {
        handler && handler();
      }
    },
    replyOpenModelHandler() {
      if (!this.modalIsOpen) {
        this.modalIsOpen = true;
      }
    },
    async replyHandler() {
      if (this.replyMsg === '') {
        this.$Message.info('回复不能为空。');
        return false;
      }
      const id = this.info.id;
      const unionId = this.info.unionId;
      const reply = this.replyMsg;
      this.isBtbLoading = true;
      try {
        const res = await this.$post(postReplyWorkSpecialClasses, {
          reply,
          id,
          unionId
        });
        if (res.isSucceed) {
          this.modalIsOpen = false;
          this.info.reply = this.replyMsg;
          this.$Message.success("回复成功");
        }
      } finally {
        this.isBtbLoading = false;
      }

    },
    questionType(index) {
      const arr = this.questionTypeList.filter(item => item.dicIndex === index);
      if (arr.length > 0) {
        return arr[0].dicName;
      } else {
        return "";
      }
    },
    // 获取问题类别
    async getQuestionTypeList() {
      const res = await this.$get(getQuestionTypeDic);
      if (res.isSucceed) {
        this.questionTypeList = res.rows.length ? res.rows : [];
      }
    },
    // 数据初始化
    async initData() {
      try {
        const { id, parentRoute = "" } = this.$route.query;
        this.isWorkSpecialClasses = parentRoute === "special-classes";
        const res = await this.$get(getChiefWaiterDocumentaryWorkDetail(id));
        if (res.isSucceed && res.rows) {
          if(res.rows.length>0){
            if(res.rows[0]&&res.rows[0].picture){
              let pictures=res.rows[0].picture.split(",")
              console.log(pictures)
              res.rows[0].pictures=pictures
            }
          }
          this.info = res.rows[0];
          this.replyMsg = this.info.reply || '';
          console.log(this.info);
          this.collections = this.info.questionList.filter(
            item => item.type === 1
          );
          this.resolves = this.info.questionList.filter(
            item => item.type === 2
          );
        }
      } finally {
      }
    }
  },
  created() {
    this.getQuestionTypeList();
    this.initData();
  }
};
</script>

<style scoped lang="less">
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-gray {
  color: #666;
}
.d-flex {
  display: flex;
}
.justify-content-between {
  justify-content: space-between;
}
.align-items-center {
  align-items: center;
}
.content {
  margin: 20px;
}
/deep/ .ivu-form-item {
  margin-bottom: 0;
}
/deep/ .ivu-form-item-label,
/deep/ .ivu-form-item-content {
  font-size: 16px;
}
/deep/ .ivu-form-item-content {
  line-height: 36px;
}
.card {
  background-color: white;
  border-radius: 5px;
  margin-bottom: 20px;
  .card-header {
    padding: 20px;
    border-bottom: 1px solid #dedede;
    font-size: 18px;
  }
  .card-body {
    padding: 20px;
    font-size: 16px;
    .card-title {
      color: #ff7c44;
    }
  }
}
.detail {
  color: #666;
}
.headPicUrl {
  // display: block;
  height: 80px;
  width: 80px;
  margin-bottom: 20px;
  margin-right: 10px;
}
.success {
  color: #ff7b44;
}
/deep/ .ivu-form-item-label {
  color: #9a9a9a;
}
.question {
  margin-bottom: 30px;
  font-size: 16px;
  .summary {
    color: #677a9e;
  }
}
.question-type {
  display: inline-block;
  max-width: 200px;
}
.imgbox{display: flex;display: -webkit-flex;flex-wrap: wrap;padding-bottom: 20px;margin-left: 76px;}
</style>
